// Angular
import { Component, Inject, OnDestroy } from '@angular/core';

// Libraries
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { startOfDay } from 'date-fns';
import { AppCleanup } from '../../../../../../shared/models';

@Component({
	selector: 'add-daily-report-dialog',
	templateUrl: './add-daily-report-dialog.component.html',
	styleUrls: ['./add-daily-report-dialog.component.scss'],
})
export class AddDailyReportDialogComponent extends AppCleanup implements OnDestroy {
	componentTitle: string = 'Create new daily report';
	dateSelected: Date = new Date();

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<AddDailyReportDialogComponent>
	) {
		super();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	submit() {
		this.dialogRef.close(startOfDay(this.dateSelected));
	}
}
